import { useState } from 'react';
import { db } from "../firebase";
import { ref, push } from "firebase/database";
import './ContactPage.css';

const svgProps = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' };
const PhoneIcon = ({ size = 20 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 8.81a19.79 19.79 0 01-3.07-8.63A2 2 0 012 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.11 7.3a16 16 0 006.59 6.59l1.36-1.14a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 14.92z"/></svg>);
const MapPinIcon = ({ size = 20 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>);
const ClockIcon = ({ size = 20 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>);
const NavigateIcon = ({ size = 16 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><polygon points="3 11 22 2 13 21 11 13 3 11"/></svg>);
const CheckCircleIcon = ({ size = 28 }) => (<svg width={size} height={size} viewBox="0 0 24 24" {...svgProps}><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>);

const hours = [
  { day: 'Sunday', time: '12:00 PM – 4:00 PM' },
  { day: 'Monday', time: '10:00 AM – 7:00 PM' },
  { day: 'Tuesday', time: '10:00 AM – 7:00 PM' },
  { day: 'Wednesday', time: '10:00 AM – 7:00 PM' },
  { day: 'Thursday', time: '10:00 AM – 7:00 PM' },
  { day: 'Friday', time: '10:00 AM – 7:00 PM' },
  { day: 'Saturday', time: '10:00 AM – 7:00 PM' },
];

const todayIndex = new Date().getDay();
const dayMap = [0, 1, 2, 3, 4, 5, 6];

export default function ContactPage() {
  const [form, setForm] = useState({ name: '', phone: '', device: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const contactRef = ref(db, "contacts");

      await push(contactRef, {
        name: form.name,
        phone: form.phone,
        device: form.device,
        message: form.message,
        createdAt: new Date().toISOString()
      });

      setSent(true);

      setForm({
        name: "",
        phone: "",
        device: "",
        message: ""
      });

    } catch (error) {
      console.error("Error saving message:", error);
    }
  };

  const todayIdx = dayMap[todayIndex];

  return (
    <div className="contact-page">
      {/* ── PAGE HERO ── */}
      <section className="page-hero">
        <div className="page-hero__container">
          <span className="page-hero__tag">Get in Touch</span>
          <h1 className="page-hero__title">Contact Us</h1>
          <p className="page-hero__sub">
            Walk in, call, or send us a message. We're here to help Monday through Saturday.
          </p>
          <div className="page-hero__pills">
            <span>8239 Troy Pike, Huber Heights, OH</span>
            <span>(937) 235-0298</span>
          </div>
        </div>
      </section>

      {/* ── MAIN GRID ── */}
      <section className="cp-main">
        <div className="cp-main__container">
          {/* Left — contact info */}
          <div className="cp-info">
            <div className="cp-card">
              <div className="cp-card__icon"><PhoneIcon size={18} /></div>
              <div>
                <h3 className="cp-card__label">Phone</h3>
                <a href="tel:9372350298" className="cp-card__phone">(937) 235-0298</a>
                <p className="cp-card__note">Fastest way to reach us — we pick up!</p>
              </div>
            </div>
            <div className="cp-card">
              <div className="cp-card__icon"><MapPinIcon size={18} /></div>
              <div>
                <h3 className="cp-card__label">Address</h3>
                <p className="cp-card__value">8239 Troy Pike<br />Huber Heights, OH 45424</p>
                <p className="cp-card__note">Next to Marshall's in NorthPark Center</p>
              </div>
            </div>
            <div className="cp-card cp-card--hours">
              <div className="cp-card__icon"><ClockIcon size={18} /></div>
              <div style={{flex:1}}>
                <h3 className="cp-card__label">Store Hours</h3>
                <div className="cp-hours">
                  {hours.map((h, i) => (
                    <div className={`cp-hours__row ${i === todayIdx ? 'cp-hours__row--today' : ''}`} key={i}>
                      <span className="cp-hours__day">{h.day}</span>
                      <span className={`cp-hours__time ${h.closed ? 'cp-hours__time--closed' : ''}`}>{h.time}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Right — map */}
          <div className="cp-right">
            <div className="cp-map">
              <iframe
                title="Fix'n More Location"
                src="https://maps.google.com/maps?q=Fix%27n+More%2C+8239+Troy+Pike%2C+Huber+Heights%2C+OH+45424&output=embed&z=16"
                width="100%" height="100%"
                style={{ border: 0 }} allowFullScreen="" loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            <div className="cp-map-actions">
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=8239+Troy+Pike+Huber+Heights+OH+45424"
                target="_blank" rel="noopener noreferrer"
                className="cp-map-btn cp-map-btn--primary"
              >
                <NavigateIcon size={15} /> Get Directions
              </a>
              <a href="tel:9372350298" className="cp-map-btn">
                <PhoneIcon size={15} /> Call Now
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ── CONTACT FORM ── */}
      <section className="cp-form-section">
        <div className="cp-form-container">
          <div className="cp-form-header">
            <span className="cp-form-tag">Send a Message</span>
            <h2 className="cp-form-title">Have a Question?</h2>
            <p className="cp-form-sub">Fill out the form below and we'll get back to you as soon as possible.</p>
          </div>
          {sent ? (
            <div className="cp-form-success">
              <div className="cp-form-success__icon"><CheckCircleIcon size={26} /></div>
              <h3>Message Sent!</h3>
              <p>Thanks for reaching out! We'll get back to you shortly. Or call us directly at <a href="tel:9372350298">(937) 235-0298</a>.</p>
            </div>
          ) : (
            <form className="cp-form" onSubmit={handleSubmit}>
              <div className="cp-form__row">
                <div className="cp-form__group">
                  <label className="cp-form__label">Your Name</label>
                  <input className="cp-form__input" type="text" placeholder="John Smith"
                    value={form.name} onChange={e => setForm({...form, name: e.target.value})} required />
                </div>
                <div className="cp-form__group">
                  <label className="cp-form__label">Phone Number</label>
                  <input className="cp-form__input" type="tel" placeholder="(937) 555-1234"
                    value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} />
                </div>
              </div>
              <div className="cp-form__group">
                <label className="cp-form__label">Device (optional)</label>
                <input className="cp-form__input" type="text"
                  placeholder="e.g. iPhone 14 Pro, Samsung Galaxy S23..."
                  value={form.device} onChange={e => setForm({...form, device: e.target.value})} />
              </div>
              <div className="cp-form__group">
                <label className="cp-form__label">Message</label>
                <textarea className="cp-form__textarea"
                  placeholder="Tell us what's wrong with your device or what you need..."
                  rows={5} value={form.message} onChange={e => setForm({...form, message: e.target.value})} required />
              </div>
              <button type="submit" className="cp-form__submit">Send Message →</button>
            </form>
          )}
        </div>
      </section>
    </div>
  );
}
